import type { ComponentStyleConfig } from "@chakra-ui/react";

export const checkboxStyles: ComponentStyleConfig = {
  baseStyle: {
    container: {
      alignItems: "flex-start",
    },
    control: {
      mt: "1",
      bg: "white",
      _checked: {
        bg: "primary",
        borderColor: "primary",
        _hover: {
          bg: "primary",
          borderColor: "primary",
        },
      },
    },
    label: {
      alignSelf: "flex-start",
    },
  },
};
